import http from "infra/http";
import { useQuery } from "react-query";
import { InstrucaoBoletoResponse } from "../typings";

function useInstrucoesBoleto(tenantId: string) {
  return useQuery([`/v1/instrucao-boleto`], async () => {
    const { data } = await http.get<InstrucaoBoletoResponse[]>(
      `/v1/instrucao-boleto`,
      {
        headers: {
          tenant: tenantId,
        },
      }
    );

    return data;
  });
}

export default useInstrucoesBoleto;
